import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LEAVE, LEAVEALL } from '../../services/actions';
import { Button, Box, Typography, Container, Paper, Grid, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import RFG from '../../libs/inputs/RFG';
import XTable from '../extra/XTableAnother';
import ActionBar from '../extra/ActionBar';
import { FormHeroHeader, FormSectionCard, FormFooter, labelStyle } from '../extra/FormLayout';
import { BsClockFill } from 'react-icons/bs';

export default function MyLeaves() {
    const dispatch = useDispatch();
    const leaveAllState = useSelector(state => state.leaveallState);
    const leaves = Array.isArray(leaveAllState?.data) ? leaveAllState.data : (leaveAllState?.data?.results || []);
    
    const [open, setOpen] = useState(false);
    const { handleSubmit, control, reset, formState: { errors } } = useForm({
        defaultValues: { leave_type: 'Sick Leave', start_date: '', end_date: '', reason: '' },
        mode: "all"
    });

    useEffect(() => {
        dispatch({ type: `${LEAVEALL}_GET`, payload: "attendance/leave/" });
    }, [dispatch]);

    const onSubmit = (data) => {
        dispatch({ type: `${LEAVE}_POST`, payload: { url: "attendance/leave/", payload: data } });
        reset({ leave_type: 'Sick Leave', start_date: '', end_date: '', reason: '' });
        setOpen(false);
        setTimeout(() => dispatch({ type: `${LEAVEALL}_GET`, payload: "attendance/leave/" }), 500);
    };

    const tableHeadings = ["Type", "Start", "End", "Status"];
    const tableRows = leaves.map(l => ({
        id: l.id,
        type: l.leave_type,
        start: l.start_date,
        end: l.end_date,
        status: l.status
    }));

    return (
        <Container maxWidth="false" className="py-3">
            {open ? (
                <Box sx={{ py: 3, px: { xs: 1, md: 3 }, maxWidth: '1400px', mx: 'auto' }}>
                    <FormHeroHeader
                        icon={<BsClockFill size={26} />}
                        title="Apply for Leave"
                        subtitle="Submit your leave application, specify duration, and provide necessary justification."
                        badgeText="Attendance & Leave"
                    />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <FormSectionCard
                            icon={<BsClockFill size={20} />}
                            title="Leave Request Details"
                            subtitle="Select leave type, duration dates, and reason for absence"
                        >
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Stack spacing={2.5}>
                                        <RFG name="leave_type" label="Leave Type *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                            <select>
                                                <option value="Sick Leave">Sick Leave</option>
                                                <option value="Casual Leave">Casual Leave</option>
                                                <option value="Paid Leave">Paid Leave</option>
                                                <option value="Half-Day">Half-Day</option>
                                            </select>
                                        </RFG>
                                        <RFG name="start_date" label="Start Date *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                            <input type="date" autoComplete="false" />
                                        </RFG>
                                        <RFG name="end_date" label="End Date *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                            <input type="date" autoComplete="false" />
                                        </RFG>
                                    </Stack>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Stack spacing={2.5}>
                                        <RFG name="reason" label="Reason for Leave *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                            <textarea style={{ height: 204 }} autoComplete="false" placeholder="Please provide detailed reason or justification for your leave application..." rows={7} />
                                        </RFG>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </FormSectionCard>
                        <FormFooter onCancel={() => setOpen(false)} backText="Cancel" submitText="Apply Leave" backTestId="back-leave-btn" saveTestId="save-leave-btn" />
                    </form>
                </Box>
            ) : (
                <>
                    <ActionBar
                        showGrid={[2]}
                        btnImport=""
                        label="My Leaves"
                        setOpen={() => setOpen(true)}
                        hasPermission={true}
                        btnLabel="APPLY LEAVE"
                    />
                    <Paper elevation={0} sx={{ mt: 2 }}>
                        <XTable
                            head={tableHeadings}
                            rows={tableRows}
                        />
                    </Paper>
                </>
            )}
        </Container>
    );
}
